import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const useStyles = makeStyles(customInputStyle);

export default function Users({ users = [], onEditUser, onToggleUser, onResendEmail, buttonsSave, agencyId = 0 }) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <Button
              variant="green"
              onClick={() => { window.location.href = `/admin/user/${agencyId}` }}
              style={{ float: "right", marginBottom: 40 }}
            >
              Add User
            </Button>
            <h3>Agency Users</h3>
          </CardHeader>
          <div className="content">
            {users.length === 0 && (
              <div style={{ padding: 20, textAlign: "center" }}>No users found.</div>
            )}
            {users.map((user, idx) => (
              <div
                key={user.id || idx}
                style={{
                  background: user.activated === "0" || user.activated === 0 ? "#ffff44" : "#fff",
                  border: "1px solid #eee",
                  borderRadius: 6,
                  marginBottom: 12,
                  padding: 16,
                  position: "relative",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                  {user.first_name} {user.last_name}
                </div>
                <div style={{ margin: "4px 0" }}>
                  <i className="fa fa-mobile-phone" /> {user.phone}
                  {user.activated === "0" || user.activated === 0 ? (
                    <span style={{ color: "#ff0000", float: "right", fontWeight: "bold" }}>
                      Note: User needs activation
                    </span>
                  ) : null}
                </div>
                <div>
                  <Tooltip title={user.activated === "0" || user.activated === 0 ? "Enable User" : "Disable User"} arrow>
                    <Button
                      justIcon
                      size="sm"
                      onClick={() => onToggleUser && onToggleUser(user)}
                      style={{ marginRight: 8, backgroundColor: user.activated === "0" || user.activated === 0 ? "#4caf50" : "#f44336" }}
                    >
                      {user.activated === "0" || user.activated === 0 ? <CheckIcon /> : <CloseIcon />}
                    </Button>
                  </Tooltip>
                  <Tooltip title="Edit User" arrow>
                    <Button
                      justIcon
                      color="primary"
                      size="sm"
                      onClick={() => { window.location.href = `/admin/user/${agencyId}/${user.id}` }}
                      style={{ marginRight: 8, backgroundColor: "#2196f3" }}
                    >
                      <EditIcon />
                    </Button>
                  </Tooltip>
                  {user.activated === "0" || user.activated === 0 ? (
                    <Tooltip title="Send Confirmation Again" arrow>
                      <Button
                        justIcon
                        color="primary"
                        size="sm"
                        onClick={() => onResendEmail && onResendEmail(user)}
                        style={{ backgroundColor: "#9c27b0" }}
                      >
                        <EmailIcon />
                      </Button>
                    </Tooltip>
                  ) : null}
                </div>
                <div style={{ marginTop: 4 }}>
                  <i className="fa fa-envelope" /> {user.email}
                </div>
              </div>
            ))}
          </div>
        </Card>
      </GridItem>
      {buttonsSave()}
    </GridContainer>
  );
}